import React from 'react';

import { InstantReflex, ReflexStep } from 'shiftNotes/_types';
import * as Styled from 'shiftNotes/styles/NotesStack.style';

import NoteCardAskForPhoto from './NoteCardAskForPhoto';
import NoteCardComposeMessage from './NoteCardComposeMessage';
import NoteCardGiveAnswerSources from './NoteCardGiveAnswerSources';
import NoteCardPrefillForm from './NoteCardPrefillForm';

export const GUIDANCE_STEP_TYPES = new Set<ReflexStep['step_type']>([
  'compose_message',
  'prefill_form',
  'ask_for_photo',
  'text',
]);

interface NoteCardReflexStepContentProps {
  step: ReflexStep;
  instantReflex: InstantReflex;
  noteId: string;
}

export default function NoteCardReflexStepContent({
  step,
  instantReflex,
  noteId,
}: NoteCardReflexStepContentProps): JSX.Element {
  const reflexId = instantReflex.id;
  const title = step.title && <Styled.StepTitle>{step.title}</Styled.StepTitle>;

  if (step.step_type === 'give_answer') {
    return (
      <>
        {step.title && (
          <Styled.ExpandableStepBody>{step.title}</Styled.ExpandableStepBody>
        )}
        {step.body && (
          <Styled.ExpandableStepBody>{step.body}</Styled.ExpandableStepBody>
        )}
        <NoteCardGiveAnswerSources
          documentTranslations={instantReflex.rag?.document_translations}
          noteId={noteId}
          reflexId={reflexId}
          stepId={step.id}
        />
      </>
    );
  }

  if (step.step_type === 'compose_message') {
    return (
      <>
        {title}
        <NoteCardComposeMessage
          step={step}
          noteId={noteId}
          reflexId={reflexId}
        />
      </>
    );
  }

  if (step.step_type === 'ask_for_photo') {
    return (
      <>
        {title}
        <NoteCardAskForPhoto step={step} noteId={noteId} reflexId={reflexId} />
      </>
    );
  }

  if (step.step_type === 'prefill_form') {
    return (
      <>
        {title}
        <NoteCardPrefillForm step={step} noteId={noteId} reflexId={reflexId} />
      </>
    );
  }

  return (
    <>
      {title}
      {step.body && (
        <Styled.ExpandableStepBody>{step.body}</Styled.ExpandableStepBody>
      )}
    </>
  );
}
